export interface DeleteFromShuffleDto
{
    getClientTxnId(): string;
    getServiceId(): string;
    getAPartyMsisdn(): string;
    getLanguage(): string;
    getChannelId(): string;
    getToneIdList(): string;
    getPriority(): string;
    getActivityId(): string;
    getTimeType(): string;
}

export class DeleteFromShuffleDtoImpl implements DeleteFromShuffleDto
{
  
    private timeType: string;
    private clientTxnId: string;
    private serviceId: string;
    private aPartyMsisdn: string;
    private language: string;
    private channelId: string;
    private toneIdList: string;
    private priority: string;
    private activityId: string;

    setTimeType(timeType: string)
    {
        this.timeType = timeType;
    }

    getTimeType(): string {
        return this.timeType;
    }

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string 
    {
        return this.clientTxnId;
    } 

    setServiceId(serviceId: string)
    {
        this.serviceId = serviceId;
    }
    getServiceId(): string 
    {
        return this.serviceId;
    } 

    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }
    getAPartyMsisdn(): string 
    {
        return this.aPartyMsisdn;
    } 

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }

    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }
    getChannelId(): string 
    {
        return this.channelId;
    } 

    setToneIdList(toneIdList: string)
    {
        this.toneIdList = toneIdList;
    }
    getToneIdList(): string 
    {
        return this.toneIdList;
    } 

    setPriority(priority: string)
    {
        this.priority = priority;
    }
    getPriority(): string 
    {
        return this.priority;
    } 

    setActivityId(activityId: string)
    {
        this.activityId = activityId;
    }
    getActivityId(): string 
    {
        return this.activityId;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/deletefromshuffle/deletefromshuffledto.ts